<script context="module" lang="ts">
    export async function searchDealer(keyword: string) {
        const filter: { [key: string]: any } = {
            $or: [],
        }
        const oF: any[] = filter["$or"]
        if (keyword?.match(/^\d{1,6}$/)) {
            if (keyword.length == 6) {
                oF.push({
                    number: parseInt(keyword),
                })
            } else {
                oF.push({
                    number: {
                        $gte: parseInt(keyword.padEnd(6, "0")),
                        $lte: parseInt(keyword.padEnd(6, "9")),
                    },
                })
            }
        }
        oF.push({
            $text: { $search: keyword },
        })
        const r = await getDealer(filter, 100, 0, "autocomplete", "number")

        return r.data?.map((d) => ({
            value: d.number,
            label: d.number + " - " + d.company + " (" + d.city + ")",
        }))
    }
</script>

<script lang="ts">
    import Select from "svelte-select"
    import Icon from "../../widgets/Icon.svelte"
    import { mdiChevronDown, mdiChevronUp } from "@mdi/js"
    import { _ } from "svelte-i18n"
    // @ts-ignore
    import { debounce } from "lodash"
    import { installationTypeCodesMap, modelGroupCodesMap, operationSources } from "../../../config"
    import { login, showPrices, location } from "../../../store"
    import { getDealer, getOperationGrouped } from "../../../api"
    import { getOperationTextFilter, objectIsEqual } from "../../../helper"
    import Calendar from "../../widgets/calendars/Calendar.svelte"

    export let active = false
    export let filter: any = {
        // need to initialize to avoid double trigger on extened search view
        "positions.installationType": undefined,
        "positions.modelGroup": undefined,
        _dealer: null,
        _status1: undefined,
        _status2: undefined,
        source: undefined,
    }
    export let type: number
    let extendedSearchForm = false

    let screenWidth: number

    export let addToTextFilter = (keyword: string): any[] => []

    export let processedFilter: any

    function procFilter() {
        const _newF = []
        for (let k in filter) {
            if (filter[k]) {
                switch (k) {
                    case "_dateFrom":
                        _newF.push({
                            $or: [
                                { inquiryDate: { $gte: { $date: new Date(filter[k]) } } },
                                { releaseDate: { $gte: { $date: new Date(filter[k]) } } },
                                /*...($location?.path?.includes("operations-out")
                                    ? [{ insertTime: { $gte: { $date: new Date(filter[k]) } } }]
                                    : []),*/
                            ],
                        })
                        break
                    case "_dateTo":
                        let _d = new Date(filter[k])
                        _d.setDate(_d.getDate() + 1)
                        _newF.push({
                            $or: [
                                { inquiryDate: { $lt: { $date: _d } } },
                                { releaseDate: { $lt: { $date: _d } } },
                                /*...($location?.path?.includes("operations-out")
                                    ? [{ insertTime: { $lt: { $date: new Date(filter[k]) } } }]
                                    : []),*/
                            ],
                        })
                        break
                    case "_sumFrom":
                        _newF.push({
                            sumNetPrice: { $gte: filter[k] },
                        })
                        break
                    case "_sumTo":
                        _newF.push({
                            sumNetPrice: { $lte: filter[k] },
                        })
                        break
                    case "_status1":
                        if (type == 1) {
                            // nur bei angeboten
                            switch (filter[k]) {
                                case "inProgress":
                                    _newF.push({
                                        "statusSummary.created": { $lt: 100 },
                                    })
                                    break
                                case "created":
                                    _newF.push({
                                        "statusSummary.created": 100,
                                    })
                                    break
                                case "outOfferCreated":
                                    _newF.push({
                                        "statusOutSummary.offerCreated": { $gt: 0 },
                                    })
                                    break
                                case "ordered":
                                    _newF.push({
                                        "orderedSummary.ordered": { $gt: 0 },
                                    })
                                    break
                                case "emailed":
                                    _newF.push({
                                        "statusSummary.emailed": { $gt: 0 },
                                    })
                                    break
                                case "orderConfimationEmailed":
                                    _newF.push({
                                        "statusSummary.orderConfimationEmailed": { $gt: 0 },
                                    })
                                    break
                                case "open_dealer":
                                    _newF.push({
                                        customDealerStatus: "open",
                                    })
                                    break
                                case "lost_dealer":
                                    _newF.push({
                                        customDealerStatus: "lost",
                                    })
                                    break
                                case "won_dealer":
                                    _newF.push({
                                        customDealerStatus: "won",
                                    })
                                    break
                                case "waitingForResponse_dealer":
                                    _newF.push({
                                        customDealerStatus: "waitingForResponse",
                                    })
                                    break
                                case "followup_dealer":
                                    _newF.push({
                                        customDealerStatus: "followUp",
                                    })
                                    break
                                case "locked_dealer":
                                    _newF.push({
                                        customDealerStatus: "locked",
                                    })
                                    break
                                case "open_internal":
                                    _newF.push({
                                        customInternalStatus: "open",
                                    })
                                    break
                                case "lost_internal":
                                    _newF.push({
                                        customInternalStatus: "lost",
                                    })
                                    break
                                case "won_internal":
                                    _newF.push({
                                        customInternalStatus: "won",
                                    })
                                    break
                                case "waitingForResponse_internal":
                                    _newF.push({
                                        customInternalStatus: "waitingForResponse",
                                    })
                                    break
                                case "followup_internal":
                                    _newF.push({
                                        customInternalStatus: "followUp",
                                    })
                                    break
                                case "locked_internal":
                                    _newF.push({
                                        customInternalStatus: "locked",
                                    })
                                    break
                            }
                        }
                        break
                    case "_status2":
                        if (type == 2) {
                            // nur beo aufträgen
                            switch (filter[k]) {
                                case "ordered":
                                    _newF.push({
                                        "statusSummary.confirmed": { $lt: 60 },
                                    })
                                    break
                                case "confirmed":
                                    _newF.push({
                                        "statusSummary.confirmed": { $gte: 60 },
                                    })
                                    break
                                case "inObjectionPeriod":
                                    _newF.push({
                                        positions: {
                                            $elemMatch: {
                                                "status.code": { $lte: 44 },
                                                objectionPeriodEnd: {
                                                    $gt: { $date: new Date() },
                                                },
                                            },
                                        },
                                    })
                                    break
                                case "delayed":
                                    _newF.push({
                                        positions: {
                                            $elemMatch: {
                                                "status.code": { $lte: 91 },
                                                "delivery.plannedDate": {
                                                    $lt: { $date: new Date() },
                                                },
                                                "status.blockingIndicator": { $ne: 2 },
                                            },
                                        },
                                    })
                                    break
                                case "manufactured":
                                    _newF.push({
                                        "statusSummary.manufactured": {
                                            $gte: 30,
                                        },
                                    })
                                    _newF.push({
                                        "statusSummary.manufactured": {
                                            $lt: 100,
                                        },
                                    })
                                    break
                                case "readyToShip":
                                    _newF.push({
                                        "statusSummary.readyToShip": {
                                            $gte: 30,
                                        },
                                    })
                                    _newF.push({
                                        "statusSummary.readyToShip": {
                                            $lt: 100,
                                        },
                                    })
                                    break
                                case "inShipment":
                                    _newF.push({
                                        "statusSummary.readyToShip": {
                                            $gte: 60,
                                        },
                                    })
                                    _newF.push({
                                        "statusSummary.inShipment": {
                                            $lt: 100,
                                        },
                                    })
                                    break
                                case "delivered":
                                    _newF.push({
                                        "statusSummary.inShipment": {
                                            $gte: 60,
                                        },
                                    })
                                    break
                                case "canceled":
                                    _newF.push({
                                        "statusSummary.canceled": { $gt: 0 },
                                    })
                                    break
                                case "emailed":
                                    _newF.push({
                                        "statusSummary.emailed": { $gt: 0 },
                                    })
                                    break
                                case "orderConfimationEmailed":
                                    _newF.push({
                                        "statusSummary.orderConfimationEmailed": { $gt: 0 },
                                    })
                                    break
                                case "open_dealer":
                                    _newF.push({
                                        customDealerStatus: "open",
                                    })
                                    break
                                case "waitingForResponse_dealer":
                                    _newF.push({
                                        customDealerStatus: "waitingForResponse",
                                    })
                                    break
                                case "followup_dealer":
                                    _newF.push({
                                        customDealerStatus: "followUp",
                                    })
                                    break
                                case "open_internal":
                                    _newF.push({
                                        customInternalStatus: "open",
                                    })
                                    break
                                case "waitingForResponse_internal":
                                    _newF.push({
                                        customInternalStatus: "waitingForResponse",
                                    })
                                    break
                                case "followup_internal":
                                    _newF.push({
                                        customInternalStatus: "followUp",
                                    })
                                    break
                            }
                        }
                        break
                    case "_text":
                        const _v = filter[k] as string
                        _newF.push(getOperationTextFilter(_v, addToTextFilter(_v)))
                        break
                    case "_dealer":
                        _newF.push({
                            dealerNumber: filter[k].value,
                        })
                        break
                    default:
                        const _f: { [key: string]: any } = {}
                        _f[k] = filter[k]
                        _newF.push(_f)
                }
            }
        }

        const count = _newF.length
        if (count) {
            processedFilter = _newF
        } else {
            processedFilter = undefined
        }
    }

    const autoProcFilter = debounce(() => {
        if (screenWidth > 1024) {
            // mobile will triggered manually
            procFilter()
        }
    }, 1000)

    let oldFilter: object
    $: if (!objectIsEqual(oldFilter, filter)) {
        autoProcFilter()
        oldFilter = { ...filter }
    }
    $: if (type) {
        procFilter()
    }

    export function resetFilter() {
        statusValue = {
            label: statusValues["undefined"],
            value: undefined,
        }
        sourceValue = {
            label: sourceValues["undefined"],
            value: undefined,
        }
        dealerValue = null
        groupedValueOperationValue = null
        modelGroupValue = null
        internalClerkGroupValue = null
        agent1GroupValue = null

        filter = {}
        procFilter()
        active = false
    }

    let statusValues: { [key: string]: string } = {
        undefined: $_("components.operationsFilter.undefined"),
    }
    let statusValue = {
        label: statusValues[type == 1 ? "" + filter._status1 : "" + filter._status2],
        value: type == 1 ? filter._status1 : filter._status2,
    }

    $: {
        statusValues =
            type == 1
                ? {
                      undefined: $_("components.operationsFilter.undefined"),
                      inProgress: $_("components.operationsFilter.inProgress"),
                      created: $_("components.operationsFilter.created"),
                      outOfferCreated: $_("components.operationsFilter.outOfferCreated"),
                      ordered: $_("components.operationsFilter.ordered"),
                      open_dealer: `${$_("components.operationsFilter.open_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      lost_dealer: `${$_("components.operationsFilter.lost_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      won_dealer: `${$_("components.operationsFilter.won_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      waitingForResponse_dealer: `${$_(
                          "components.operationsFilter.waitingForResponse_dealer"
                      )}::group:${$_("components.operationsFilter.user_status")}`,
                      followup_dealer: `${$_("components.operationsFilter.followup_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      locked_dealer: `${$_("components.operationsFilter.locked_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      open_internal: `${$_("components.operationsFilter.open_internal")}::group:${$_("components.operationsFilter.internal_status")}`,
                      lost_internal: `${$_("components.operationsFilter.lost_internal")}::group:${$_("components.operationsFilter.internal_status")}`,
                      won_internal: `${$_("components.operationsFilter.won_internal")}::group:${$_("components.operationsFilter.internal_status")}`,
                      waitingForResponse_internal: `${$_(
                          "components.operationsFilter.waitingForResponse_internal"
                      )}::group:${$_("components.operationsFilter.internal_status")}`,
                      followup_internal: `${$_(
                          "components.operationsFilter.followup_internal"
                      )}::group:${$_("components.operationsFilter.internal_status")}`,
                      locked_internal: `${$_("components.operationsFilter.locked_internal")}::group:${$_("components.operationsFilter.internal_status")}`,
                  }
                : {
                      undefined: $_("components.operationsFilter.undefined"),
                      ordered: $_("components.operationsFilter.ordered"),
                      confirmed: $_("components.operationsFilter.confirmed"),
                      inObjectionPeriod: $_("components.operationsFilter.inObjectionPeriod"),
                      delayed: $_("components.operationsFilter.delayed"),
                      manufactured: $_("components.operationsFilter.manufactured"),
                      readyToShip: $_("components.operationsFilter.readyToShip"),
                      inShipment: $_("components.operationsFilter.inShipment"),
                      delivered: $_("components.operationsFilter.delivered"),
                      canceled: $_("components.operationsFilter.canceled"),
                      open_dealer: `${$_("components.operationsFilter.open_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      waitingForResponse_dealer: `${$_(
                          "components.operationsFilter.waitingForResponse_dealer"
                      )}::group:${$_("components.operationsFilter.user_status")}`,
                      followup_dealer: `${$_("components.operationsFilter.followup_dealer")}::group:${$_("components.operationsFilter.user_status")}`,
                      open_internal: `${$_("components.operationsFilter.open_internal")}::group:${$_("components.operationsFilter.internal_status")}`,
                      waitingForResponse_internal: `${$_(
                          "components.operationsFilter.waitingForResponse_internal"
                      )}::group:${$_("components.operationsFilter.internal_status")}`,
                      followup_internal: `${$_(
                          "components.operationsFilter.followup_internal"
                      )}::group:${$_("components.operationsFilter.internal_status")}`,
                  }

        // remove internal status for dealer
        if (!($login?.account.roles?.includes("A") || $login?.account.roles?.includes("R"))) {
            delete statusValues["open_internal"]
            delete statusValues["lost_internal"]
            delete statusValues["won_internal"]
            delete statusValues["waitingForResponse_internal"]
            delete statusValues["followup_internal"]
            delete statusValues["locked_internal"]
        }

        // remove dealer status for renz clerk
        if ($login?.account.roles?.includes("R")) {
            delete statusValues["open_dealer"]
            delete statusValues["lost_dealer"]
            delete statusValues["won_dealer"]
            delete statusValues["waitingForResponse_dealer"]
            delete statusValues["followup_dealer"]
            delete statusValues["locked_dealer"]
        }

        // reset status value if not in values
        if (!Object.keys(statusValues).includes(statusValue.value)) {
            statusValue = {
                label: statusValues["undefined"],
                value: undefined,
            }
        }
    }

    if ($location?.path?.includes("operations-out")) {
        statusValues["emailed"] = $_("components.operationsFilter.offerSent")
        statusValues["orderConfimationEmailed"] = $_("components.operationsFilter.taskSent")
        delete statusValues["ordered"]
    }

    $: if (type == 1) {
        filter._status1 = statusValue?.value
    } else {
        filter._status2 = statusValue?.value
    }

    let sourceValues: { [key: string]: string } = {
        undefined: $_("components.operationsFilter.allSources"),
    }
    Object.keys(operationSources).forEach((k) => {
        const n = parseInt(k)
        sourceValues[n] = operationSources[n].label
    })

    let sourceValue = {
        label: sourceValues[filter.source],
        value: filter.source,
    }
    $: filter.source = parseInt(sourceValue?.value)

    async function loadDealer(filter: any, limit?: number, offset?: number, projection?: string) {
        const r = await getDealer(filter, limit, offset, projection)
        if (r.data) {
            r.data = r.data.sort((a, b) => {
                if (a.number == $login?.account.ident.dealerNumber) {
                    return -1
                }
                if (b.number == $login?.account.ident.dealerNumber) {
                    return 1
                }
                return a.number < b.number ? -1 : 1
            })
            const values = r.data.map((d) => ({
                value: d.number,
                label: d.number + " - " + d.company + " (" + d.city + ")",
            }))
            values.push({
                // @ts-ignore
                value: null,
                label: $_("components.operationsFilter.all"),
            })
            return values
        }
        return []
    }

    let dealerValue: { label: string; value: any } = null

    $: filter._dealer = dealerValue?.value ? { value: dealerValue.value } : null

    async function loadGroupedOperations(
        _groupBy: string,
        codeMap?: {
            [key: string]: {
                de: string
            }
        },
        showCode?: boolean,
        filterText?: string
    ) {
        const r = await getOperationGrouped(
            _groupBy,
            codeMap
                ? null
                : filterText
                  ? {
                        [_groupBy]: {
                            $regex: filterText.replace(/[^a-zA-Z0-9 ]/g, "") || "",
                            $options: "i",
                        },
                    }
                  : null
        )
        if (r.data) {
            if (codeMap) {
                r.data = r.data.sort((a, b) => (a.v < b.v ? -1 : 1))
                let values = r.data.map((d) => {
                    if (!!d.v)
                        return {
                            value: d.v,
                            label: `${showCode ? d?.v + " | " : ""}${codeMap[d?.v]?.de}`,
                        }
                })
                values = values.filter((v) => {
                    if (!v) return false
                    if (filterText) {
                        return v.label.toLowerCase().includes(filterText.toLowerCase())
                    }
                    return true
                })
                return values
            }
            r.data = r.data.sort((a, b) => (a.c > b.c ? -1 : 1))
            let values = r.data.map((d) => {
                if (!!d.v)
                    return {
                        value: d.v,
                        label: d.v,
                    }
            })
            values = values.filter((v) => !!v)
            return values
        }
        return []
    }
    let groupedValueOperationValue: { label: string; value: any } = null
    $: filter["positions.installationType"] = groupedValueOperationValue?.value

    let modelGroupValue: { label: string; value: any } = null
    $: filter["positions.modelGroup"] = modelGroupValue?.value

    let internalClerkGroupValue: { label: string; value: any } = null
    $: filter["internalClerk.name"] = internalClerkGroupValue?.value

    let agent1GroupValue: { label: string; value: any } = null
    $: filter["agent1.name"] = agent1GroupValue?.value
</script>

<style global>
    .svelte-select {
        width: 100%;
    }
</style>

<!-- Filter -->
<div class="filter_container" class:active>
    <div class="filter_topbar">
        <div class="headline">{$_("components.operationsFilter.filter")}</div>
    </div>
    <section class="filter_section" id="filtersection1">
        <div class="row">
            <div class="col-lg-5 no-padding">
                <div class="row">
                    <div class="col-sm-4">
                        <label for="">{$_("components.operationsFilter.status")}</label>
                        <Select
                            placeholder="{$_('components.operationsFilter.selectStatus')}"
                            value="{statusValue}"
                            groupHeaderSelectable="{true}"
                            groupBy="{(item = { group: '' }) => item.group}"
                            items="{Object.entries(statusValues).map((e) => ({
                                label: e[1].split('::group:')[0],
                                value: e[0],
                                group: e[1].split('::group:')[1] || '',
                            }))}"
                            clearable="{true}"
                            on:change="{(e) => {
                                statusValue = e.detail
                            }}"
                            on:clear="{() => {
                                statusValue = { label: statusValues['undefined'], value: '' }
                            }}"
                        />
                    </div>
                    <div class="col-sm-4">
                        <label for="">{$_("components.operationsFilter.origin")}</label>
                        <Select
                            placeholder="{$_('components.operationsFilter.selectOrigin')}"
                            value="{sourceValue}"
                            items="{Object.entries(sourceValues).map((e) => ({ label: e[1], value: e[0] }))}"
                            clearable="{true}"
                            on:change="{(e) => {
                                sourceValue = e.detail
                            }}"
                            on:clear="{() => {
                                sourceValue = { label: sourceValues['undefined'], value: '' }
                            }}"
                        />
                    </div>
                    <div class="col-sm-4 no-padding-right" data-cy="free-search">
                        <label for="">{$_("components.operationsFilter.freeSearch")}</label>
                        <div class="search">
                            <input
                                type="text"
                                placeholder="{$_('address.enterSearchTerm')}"
                                bind:value="{filter._text}"
                            />
                            <span class="material-icons icon">search</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 no-padding">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-xs-6">
                                <label for=""
                                    >{$_("components.operationsFilter.filterTimeRange")}
                                    {$_("components.operationsFilter.from")}</label
                                >

                                <Calendar
                                    placeholder="{$_('components.operationsFilter.from')}"
                                    deactivateDateValueString="{true}"
                                    bind:dateValue="{filter._dateFrom}"
                                />
                            </div>
                            <div class="col-xs-6">
                                <label for="">{$_("components.operationsFilter.until")}</label>

                                <Calendar
                                    placeholder="{$_('components.operationsFilter.until')}"
                                    deactivateDateValueString="{true}"
                                    bind:dateValue="{filter._dateTo}"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 no-padding-left">
                        {#if $login?.account?.roles?.includes("A") || $login?.account?.roles?.includes("R")}
                            <label for="">{$_("components.operationsFilter.dealerCustomers")}</label>
                            <Select
                                placeholder="{$_('components.operationsFilter.enterNumberOrName')}"
                                clearable="{true}"
                                loadOptions="{searchDealer}"
                                value="{dealerValue}"
                                on:change="{(e) => {
                                    dealerValue = e.detail
                                }}"
                                on:clear="{() => {
                                    dealerValue = null
                                }}"
                            />
                        {:else if $login?.tokenData?.dealers?.length}
                            <label for="">{$_("components.operationsFilter.dealerCustomers")} </label>

                            <Select
                                inputAttributes="{{ autocomplete: 'off' }}"
                                placeholder="{$_('components.operationsFilter.all')}"
                                clearable="{true}"
                                loadOptions="{async () => await loadDealer(null, undefined, undefined, 'autocomplete')}"
                                value="{dealerValue}"
                                on:change="{(e) => {
                                    dealerValue = e.detail
                                }}"
                                on:clear="{() => {
                                    dealerValue = null
                                }}"
                            />
                        {/if}
                    </div>
                    <div class="col-sm-3">
                        <label for="">{$_("components.operationsFilter.advancedSearch")} </label>
                        <button
                            data-cy="toggle-extended-search"
                            class="form_button"
                            on:click="{() => {
                                extendedSearchForm = !extendedSearchForm
                            }}"><Icon path="{extendedSearchForm ? mdiChevronUp : mdiChevronDown}" size="32px" /></button
                        >
                    </div>
                </div>
            </div>
        </div>
    </section>
    {#if extendedSearchForm}
        <section class="filter_section" id="filtersection2">
            <div class="row">
                <div class="col-md-{$showPrices ? 5 : 2} no-padding-right">
                    <div class="row">
                        {#if $showPrices}
                            <div class="col-sm-6">
                                <label for="">{$_("components.operationsFilter.unitPrice")}</label>
                                <div class="row">
                                    <div class="col-xs-6 no-padding-left">
                                        <div class="filter_summe">
                                            <input
                                                type="number"
                                                placeholder="{$_('components.operationsFilter.from')}"
                                                bind:value="{filter._sumFrom}"
                                            />
                                            <span class="material-icons icon">euro_symbol</span>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 no-padding-right">
                                        <div class="filter_summe">
                                            <input
                                                type="number"
                                                placeholder="{$_('components.operationsFilter.until')}"
                                                bind:value="{filter._sumTo}"
                                            />
                                            <span class="material-icons icon">euro_symbol</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        {/if}
                        <div class="col-sm-{$showPrices ? 6 : 12} no-padding-right">
                            <label for="">{$_("components.operationsFilter.residentialUnits")}</label>
                            <input
                                type="number"
                                placeholder="{$_('components.additionalServices.amount')}"
                                bind:value="{filter.residentialUnitsCount}"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-sm-6">
                            <label for="">{$_("components.operationsFilter.installationType")}</label>
                            <Select
                                inputAttributes="{{ autocomplete: 'off' }}"
                                placeholder="{$_('components.operationsFilter.selectInstallationType')}"
                                hideEmptyState="{true}"
                                clearable="{true}"
                                loadOptions="{async (filterText = "") =>
                                    await loadGroupedOperations(
                                        'positions.installationType',
                                        installationTypeCodesMap,
                                        false,
                                        filterText
                                    )}"
                                value="{groupedValueOperationValue}"
                                on:change="{(e) => {
                                    groupedValueOperationValue = e.detail
                                }}"
                                on:clear="{() => {
                                    groupedValueOperationValue = null
                                }}"
                            />
                        </div>
                        <div class="col-sm-6">
                            <label for="">{$_("components.operationsFilter.modelGroup")}</label>
                            <Select
                                inputAttributes="{{ autocomplete: 'off' }}"
                                placeholder="{$_('components.operationsFilter.selectModelGroup')}"
                                hideEmptyState="{true}"
                                clearable="{true}"
                                loadOptions="{async (filterText = "") =>
                                    await loadGroupedOperations(
                                        'positions.modelGroup',
                                        modelGroupCodesMap,
                                        true,
                                        filterText
                                    )}"
                                value="{modelGroupValue}"
                                on:change="{(e) => {
                                    modelGroupValue = e.detail
                                }}"
                                on:clear="{() => {
                                    modelGroupValue = null
                                }}"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {#if $login?.account?.roles?.includes("A") || $login?.account?.roles?.includes("R")}
                <div class="row">
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-sm-6">
                                <label for="">{$_("components.operationsFilter.agent")}</label>
                                <Select
                                    placeholder="{$_('components.operationsFilter.selectAgent')}"
                                    clearable="{true}"
                                    loadOptions="{async (filterText = "") =>
                                        await loadGroupedOperations('internalClerk.name', null, false, filterText)}"
                                    value="{internalClerkGroupValue}"
                                    on:change="{(e) => {
                                        internalClerkGroupValue = e.detail
                                    }}"
                                    on:clear="{() => {
                                        internalClerkGroupValue = null
                                    }}"
                                />
                            </div>
                            <div class="col-sm-6">
                                <label for="">{$_("components.operationsFilter.representative1")}</label>
                                <Select
                                    placeholder="{$_('components.operationsFilter.selectRepresentative')}"
                                    clearable="{true}"
                                    loadOptions="{async (filterText = "") =>
                                        await loadGroupedOperations('agent1.name', null, false, filterText)}"
                                    value="{agent1GroupValue}"
                                    on:change="{(e) => {
                                        agent1GroupValue = e.detail
                                    }}"
                                    on:clear="{() => {
                                        agent1GroupValue = null
                                    }}"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
        </section>
    {/if}

    <div class="buttons">
        <button
            class="btn"
            on:click="{() => {
                procFilter()
                active = false
            }}">{$_("components.operationsFilter.applyFilter")}</button
        >
        <button
            class="btn btn_grey"
            on:click="{() => {
                resetFilter()
            }}">{$_("components.operationsFilter.resetFilter")}</button
        >
    </div>
</div>

<svelte:window bind:innerWidth="{screenWidth}" />
